import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import CustomApplicationState from "@wausauCustomBlueprint/Store/CustomApplicationState";

export const getWausauRequestRMAReturnPO = (state: CustomApplicationState) => {
    return state.tData.wausauRequestRMAState.returnPO;
};
